import React from 'react';
import AreaLandingPage, { AreaConfig } from '../components/AreaLandingPage';

const dadar: AreaConfig = {
  name: 'Dadar',
  slug: 'dadar',
  tagline: 'Doorstep Mobile Repair in Dadar, Mumbai',
  description:
    "Minto brings expert mobile repair right to your door in Dadar. Whether you're in Dadar West, Shivaji Park, or Prabhadevi — a certified technician arrives at your location and repairs your phone in under an hour.",
  localities: [
    'Dadar West', 'Dadar East', 'Shivaji Park', 'Prabhadevi', 'Worli',
    'Mahim', 'Naigaon', 'Hindu Colony', 'Kohinoor', "King's Circle",
    'Matunga', 'Dharavi', 'Sion',
  ],
  zones: [
    {
      name: 'Dadar West — Shivaji Park',
      line: 'Western Line',
      station: 'Dadar West Station',
      localities: ['Shivaji Park', 'Hindu Colony', 'Kohinoor', 'Cadell Road', 'Ranade Road', 'Gokhale Road'],
      desc: "Dadar West's iconic neighbourhoods fully covered. Book a repair from Shivaji Park or Hindu Colony and a technician arrives within the hour.",
    },
    {
      name: 'Prabhadevi & Worli',
      line: 'Western Line',
      station: 'Elphinstone Road (Prabhadevi) Station',
      localities: ['Prabhadevi', 'Worli', 'Worli Sea Face', 'Century Mills', 'Lower Worli', 'Atria Mall area'],
      desc: 'Prabhadevi and Worli — from residential buildings to commercial offices — are fully served by our Dadar team.',
    },
    {
      name: 'Dadar East — Matunga & Sion',
      line: 'Central Line',
      station: 'Dadar East Station / Matunga Station / Sion Station',
      localities: ['Dadar East', 'Matunga East', 'Matunga West', 'Sion', "King's Circle", 'Dharavi', 'Naigaon'],
      desc: 'Covering the Central line corridor from Dadar East through Matunga to Sion. Same-day doorstep service for all localities.',
    },
    {
      name: 'Mahim',
      line: 'Harbour Line',
      station: 'Mahim Junction Station',
      localities: ['Mahim West', 'Mahim East', 'Bandra–Mahim boundary', 'Lady Jamshedji Road'],
      desc: 'Mahim Junction connects Western and Harbour lines. Our technicians serve both sides of Mahim including the coastal areas.',
    },
  ],
  seo: {
    title: 'Mobile Repair in Dadar | Doorstep Phone Repair Service | Minto',
    description:
      'Expert doorstep mobile repair in Dadar West, Dadar East, Shivaji Park, Prabhadevi & Worli, Mumbai. Screen replacement, battery repair. 90-day warranty. Starting ₹299. Book now!',
    keywords:
      'mobile repair Dadar, phone repair Dadar, screen repair Dadar, battery replacement Dadar, doorstep mobile repair Dadar, iPhone repair Dadar, Samsung repair Dadar, Shivaji Park phone repair, Prabhadevi mobile repair, Worli phone repair, Mahim mobile repair, Matunga phone repair, Sion mobile repair',
  },
  faqs: [
    {
      q: 'Do you offer doorstep mobile repair at Shivaji Park, Dadar?',
      a: 'Yes, we cover Shivaji Park and all of Dadar West. A technician will arrive at your home or office within 60–90 minutes.',
    },
    {
      q: 'Can you repair my phone in Prabhadevi or Worli?',
      a: 'Absolutely. Prabhadevi and Worli are part of our Dadar service zone for both residential and commercial locations.',
    },
    {
      q: 'How much does battery replacement cost in Dadar?',
      a: 'Battery replacement starts from ₹699 depending on your phone model. Select your device to see the exact price.',
    },
    {
      q: 'Do you also cover Mahim and Matunga near Dadar?',
      a: 'Yes, Mahim, Matunga, and Naigaon are within our Dadar service area. Our technicians cover these localities daily.',
    },
    {
      q: 'Is same-day repair available in Dadar?',
      a: 'Yes, same-day service is available. Book before 6 PM and a technician will visit the same day in most cases.',
    },
  ],
};

const DadarPage: React.FC = () => <AreaLandingPage area={dadar} />;
export default DadarPage;
